<template>
  <div>
    <div class="flex-between" style="padding: 20px 0">
      <!-- <el-select v-model="value" placeholder="请选择">
        <el-option
          v-for="item in options"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        >
        </el-option>
      </el-select> -->
    </div>
    <!-- 院所级别 -->
    <el-row>
      <el-col>
        <el-card>
          <div class="flex-items">
            <div class="tui-left">
              <div class="flex tui-leftContent">
                <!-- <div class="tui-leftTitle">园所概况</div> -->
                <div class="tui-leftBtn flex-center">
                  {{ scrollInfo.SchoolType }}
                </div>
                <!-- <div class="tui-leftDesc">{{ scrollInfo.SchoolName }}</div> -->
              </div>
              <div class="flex tui-leftContent">
                <!-- <div class="tui-leftTitle">{{ scrollInfo.SchoolName }}</div> -->
                <div class="tui-leftBtn flex-center">
                  {{ scrollInfo.SchoolLeval }}
                </div>
                <!-- <div class="tui-leftDesc">园所级别</div> -->
              </div>
            </div>
            <div class="tui-right">
              <div
                class="tui-rightItem"
                v-for="(item, index) in headerList"
                :key="index"
              >
                <img :src="item.img" alt="" />
                <div
                  class="flex-items tui-rightItemBox"
                  style="align-items: center"
                >
                  <p class="tui-Num">{{ item.count }}</p>
                  <p class="tui-desc">{{ item.title }}</p>
                </div>
              </div>
            </div>
          </div>
        </el-card>
      </el-col>
    </el-row>
    <!-- 智慧管理 -->
    <el-row class="flex">
      <el-col :span="16">
        <el-card class="" style="position: relative">
          <div slot="header" class="tui-cardTitle">
            <span>智慧管理</span>
          </div>
          <div class="flex-around">
            <div class="flex" style="flex-direction: column; flex: 1">
              <div>
                <div class="flex-items" style="padding-bottom: 0.25rem">
                  <div class="tui-before"></div>
                  <div class="tui-bottomTitle">幼儿考勤</div>
                </div>
                <div class="tui-right">
                  <div
                    class="tui-rightItem"
                    style="width: calc(100% / 3); margin: 0"
                    v-for="(item, index) in childrenList"
                    :key="index"
                  >
                    <div class="flex-items tui-rightItemBox" style="padding: 0">
                      <p class="tui-Num">{{ item.count }}</p>
                      <p class="tui-desc">{{ item.title }}</p>
                    </div>
                  </div>
                </div>
              </div>
              <div>
                <div class="flex-items" style="padding: 0.25rem 0">
                  <div class="tui-before"></div>
                  <div class="tui-bottomTitle">幼儿盘</div>
                </div>
                <div class="tui-right">
                  <div
                    class="tui-rightItem"
                    style="width: calc(100% / 3); margin: 0"
                    v-for="(item, index) in ChildTray"
                    :key="index"
                  >
                    <div class="flex-items tui-rightItemBox" style="padding: 0">
                      <p class="tui-Num">{{ item.count }}</p>
                      <p class="tui-desc">{{ item.title }}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="tui-border"></div>
            <div class="flex" style="flex-direction: column; flex: 1">
              <div>
                <div class="flex-items" style="padding-bottom: 0.25rem">
                  <div class="tui-before"></div>
                  <div class="tui-bottomTitle">教师考勤</div>
                </div>
                <div class="tui-right">
                  <div
                    class="tui-rightItem"
                    style="width: calc(100% / 3); margin: 0"
                    v-for="(item, index) in teacherList"
                    :key="index"
                  >
                    <div class="flex-items tui-rightItemBox" style="padding: 0">
                      <p class="tui-Num">{{ item.count }}</p>
                      <p class="tui-desc">{{ item.title }}</p>
                    </div>
                  </div>
                </div>
              </div>
              <div>
                <div class="flex-items" style="padding: 0.25rem 0">
                  <div class="tui-before"></div>
                  <div class="tui-bottomTitle">教师盘</div>
                </div>
                <div class="tui-right">
                  <div
                    class="tui-rightItem"
                    style="width: calc(100% / 3); margin: 0"
                    v-for="(item, index) in teacherTray"
                    :key="index"
                  >
                    <div class="flex-items tui-rightItemBox" style="padding: 0">
                      <p class="tui-Num">{{ item.count }}</p>
                      <p class="tui-desc">{{ item.title }}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </el-card>
      </el-col>

      <el-col :span="8" style="margin-left: 0.25rem">
        <el-card class="" style="position: relative">
          <div class="flex-between" slot="header">
            <div class="tui-cardTitle">
              <span>综合评价</span>
            </div>
            <div style="margin-left: 2.725rem">
              <el-select
                v-model="allClassId"
                placeholder="请选择班级"
                @change="onClickAllStudent"
              >
                <el-option
                  v-for="item in allClassList"
                  :key="item.Id"
                  :label="item.GradeNameAndClassName"
                  :value="item.Id"
                >
                </el-option>
              </el-select>
            </div>
          </div>

          <div>
            <div
              class="flex-around"
              v-for="(item, index) in allPie"
              :key="index"
              style="padding: 0.125rem 0"
            >
              <div class="tui-progressTitle">{{ item.Name }}</div>
              <div class="tui-progress">
                <div
                  :style="{
                    width: item.Percentage + '%',
                  }"
                ></div>
              </div>
              <div class="tui-progressResult">
                已评：{{ item.Percentage == "NaN" ? "0" : item.Percentage }}%
              </div>
            </div>
          </div>
        </el-card>
      </el-col>
    </el-row>
    <el-row class="flex">
      <el-col :span="16">
        <el-card class="" style="position: relative; height: 2.6rem">
          <div slot="header" class="tui-cardTitle">
            <span>科学教育</span>
          </div>
          <div class="flex-around">
            <div class="flex" style="flex-direction: column; flex: 1">
              <div>
                <div class="flex-items" style="padding-bottom: 0.25rem">
                  <div class="tui-before"></div>
                  <div class="tui-bottomTitle">幼儿发展</div>
                </div>
                <div class="tui-right">
                  <div
                    class="tui-rightItem"
                    style="width: calc(100% / 3); margin: 0"
                    v-for="(item, index) in smallChildrenList"
                    :key="index"
                  >
                    <div class="flex-items tui-rightItemBox" style="padding: 0">
                      <p class="tui-Num">{{ item.count }}</p>
                      <p class="tui-desc">{{ item.title }}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="tui-border" style="height: 1.2875rem"></div>
            <div class="flex" style="flex-direction: column; flex: 1">
              <div>
                <div class="flex-items" style="padding-bottom: 0.25rem">
                  <div class="tui-before"></div>
                  <div class="tui-bottomTitle">教师发展</div>
                </div>
                <div class="tui-right">
                  <div
                    class="tui-rightItem"
                    style="width: calc(100% / 3); margin: 0"
                    v-for="(item, index) in smallTeacherList"
                    :key="index"
                  >
                    <div class="flex-items tui-rightItemBox" style="padding: 0">
                      <p class="tui-Num">{{ item.count }}</p>
                      <p class="tui-desc">{{ item.title }}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </el-card>
      </el-col>
      <el-col :span="8" style="margin-left: 0.25rem">
        <el-card style="height: 2.6rem">
          <div slot="header" class="tui-cardTitle">
            <span>健康保育</span>
          </div>
          <div class="tui-right" style="padding: 0.3125rem 0 0 0">
            <div class="tui-rightItem" style="flex: 1">
              <img src="../assets/item-f2.png" alt="" />

              <div class="flex-items tui-rightItemBox">
                <p class="tui-Num">{{ healthInfoList.EatNum }}</p>
                <p class="tui-desc">今日就餐人数</p>
              </div>
            </div>
            <div class="tui-rightItem" style="flex: 1">
              <img src="../assets/item-f1.png" alt="" />
              <div class="flex-items tui-rightItemBox">
                <p class="tui-Num">{{ healthInfoList.FoodTypeNum }}</p>
                <p class="tui-desc">今日食材种类</p>
              </div>
            </div>
          </div>
        </el-card>
      </el-col>
    </el-row>
    <el-row>
      <el-col>
        <el-card class="tui-task" style="position: relative; height: 3.125rem">
          <div class="flex-between" slot="header">
            <div class="tui-cardTitle">
              <span>任务提醒</span>
            </div>
            <div style="margin-left: 2.725rem">
              <el-select
                v-model="taskAllClassId"
                placeholder="请选择班级"
                @change="onClickAllStudentTask"
              >
                <el-option
                  v-for="item in taskAllClassList"
                  :key="item.Id"
                  :label="item.GradeNameAndClassName"
                  :value="item.Id"
                >
                </el-option>
              </el-select>
            </div>
          </div>

          <div class="flex" style="justify-content: space-around">
            <div style="flex: 1">
              <div class="flex-items">
                <div class="tui-before" style="background: #fc7b39"></div>
                <div class="tui-bottomTitle">未操作评价</div>
              </div>
              <vue-seamless-scroll
                :data="allPieTask"
                class="seamless-warp"
                :class-option="optionHover"
              >
                <div
                  class="tui-taskTitle"
                  v-for="(item, index) in allPieTask"
                  :key="index"
                >
                  {{ item.Name }} {{ item.namevalue[1].value }}位幼儿未评价
                </div>
              </vue-seamless-scroll>
            </div>
            <div style="flex: 1">
              <div class="flex-items">
                <div class="tui-before" style="background: #fc7b39"></div>
                <div class="tui-bottomTitle">未完成问卷</div>
              </div>
              <vue-seamless-scroll
                :class-option="optionHover"
                :data="taskInfo.ExamInfo"
                class="seamless-warp"
              >
                <div
                  class="tui-taskTitle"
                  v-for="(item, index) in taskInfo.ExamInfo"
                  :key="index"
                >
                  {{ item.Name }}
                </div>
              </vue-seamless-scroll>
            </div>
            <div style="flex: 1">
              <div class="flex-items">
                <div class="tui-before" style="background: #fc7b39"></div>
                <div class="tui-bottomTitle">未查看通知</div>
              </div>
              <vue-seamless-scroll
                :class-option="optionHover"
                :data="taskInfo.MessageInfo"
                class="seamless-warp"
              >
                <div
                  class="tui-taskTitle"
                  v-for="(item, index) in taskInfo.MessageInfo"
                  :key="index"
                >
                  {{ item.Name }}
                </div>
              </vue-seamless-scroll>
            </div>
            <div style="flex: 1">
              <div class="flex-items">
                <div class="tui-before" style="background: #fc7b39"></div>
                <div class="tui-bottomTitle">未查看文章</div>
              </div>
              <vue-seamless-scroll
                :class-option="optionHover"
                :data="taskInfo.ArticleInfo"
                class="seamless-warp"
              >
                <div
                  class="tui-taskTitle"
                  v-for="(item, index) in taskInfo.ArticleInfo"
                  :key="index"
                >
                  {{ item.Name }}
                </div>
              </vue-seamless-scroll>
            </div>
          </div>
        </el-card>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import {
  GetTeacherAttendStatis,
  GetWebStudentAttendStatis,
  GetTeacherClassRoleInfo,
  GetSchoolBaseInfo,
  GetSchoolScienceInfo,
  GetSchoolCloudDiskInfo,
  GetSchoolDietaryInfo,
  GetOpenCycleInfoSelectResult,
  GetSchoolHealthyInfo,
  GetStudentInfoByClassId,
  GetSchoolEvalInfo,
  GetHealthInfo,
  GetTaskInfo,
} from "@/api/api.js";
import vueSeamlessScroll from "vue-seamless-scroll";

export default {
  components: {
    vueSeamlessScroll,
  },
  data() {
    return {
      headerList: [],
      childrenList: [],
      teacherList: [],
      smallChildrenList: [],
      smallTeacherList: [],
      ChildTray: [],
      teacherTray: [],
      currentIndex: 0,
      userInfo: {},
      classList: [],
      allClassList: [],
      allClassId: null,
      ClassId: null,
      classListTheme: [],
      classListThemeId: null,
      scrollInfo: {},
      DietaryInfo: {},
      CycleList: [],
      allCycleList: [],
      CycleListValue: null,
      allCycleListValue: null,
      studentList: [],
      allStudentList: [],
      studentListIndex: 0,
      allStudentListIndex: 0,
      allCurrentIndex: 0,
      allPie: [],
      options: [
        {
          value: "选项1",
          label: "黄金糕",
        },
        {
          value: "选项2",
          label: "双皮奶",
        },
        {
          value: "选项3",
          label: "蚵仔煎",
        },
        {
          value: "选项4",
          label: "龙须面",
        },
        {
          value: "选项5",
          label: "北京烤鸭",
        },
      ],
      value: "",
      healthInfoList: {},
      taskAllClassId: null,
      taskAllClassList: [],
      allPieTask: [],
      taskInfo: {},
    };
  },
  computed: {
    optionHover() {
      return {
        hoverStop: true, // 鼠标悬停停止滚动
        direction: [0, 1][0], // 向下/上滚动
        step: 0.2, // 滚动速度
        // singleHeight: 20, // 滚动单行
        // waitTime:2500 单行停顿时间
      };
    },
  },
  async created() {
    // location.reload();
    if (location.href.indexOf("#reloaded") == -1) {
      location.href = location.href + "#reloaded";
      window.location.reload();
    }
    this.userInfo = JSON.parse(window.localStorage.getItem("user"));
    this.GetSchoolBaseInfo();
    this.GetSchoolScienceInfo();
    await this.GetTeacherClassRoleInfo();
    await this.GetWebStudentAttendStatis();
    this.GetTeacherAttendStatis();
    this.GetSchoolCloudDiskInfo();
    this.GetSchoolDietaryInfo();
    this.GetOpenCycleInfoSelectResult();
    this.GetHealthInfo();
    await this.GetStudentInfoByClassId();
    // await this.GetSchoolHealthyInfo(); //健康体检
    this.GetTaskInfo();
    await this.GetSchoolEvalInfo();
    await this.GetSchoolEvalInfoTask();
  },
  mounted() {
    // this.getDataPie();
  },
  methods: {
    setFixed(item) {
      let result =
        item.namevalue[0].value /
        (item.namevalue[0].value + item.namevalue[1].value);
      return result.toFixed();
    },
    // 任务提醒
    async GetTaskInfo() {
      let res = await GetTaskInfo({
        Id: this.taskAllClassId ? this.taskAllClassId : 0,
      });
      if (res.data.success) {
        this.taskInfo = res.data.response;
      }
    },
    onChangeAllCycle(e) {
      this.allCycleListValue = e;
      this.GetSchoolEvalInfo();
    },
    onClickAllclass(index) {
      this.allCurrentIndex = index;
      this.GetSchoolEvalInfo();
    },
    onClickAllStudent(e) {
      this.allClassId = e;
      this.GetSchoolEvalInfo();
    },
    onClickAllStudentTask(e) {
      this.taskAllClassId = e;
      this.GetTaskInfo();
    },
    // 健康保育
    async GetHealthInfo() {
      let res = await GetHealthInfo();
      if (res.data.success) {
        this.healthInfoList = res.data.response;
      }
    },
    // 综合评价
    async GetSchoolEvalInfo() {
      let res = await GetSchoolEvalInfo({
        SexType: 0,
        ClassId: this.allClassId ? this.allClassId : 0,
      });
      if (res.data.success) {
        this.allPie = res.data.response;
      }
    },
    // 任务提醒第一列
    async GetSchoolEvalInfoTask() {
      let res = await GetSchoolEvalInfo({
        SexType: 0,
        ClassId: this.taskAllClassId ? this.taskAllClassId : 0,
      });
      if (res.data.success) {
        this.allPieTask = res.data.response;
      }
    },
    onClickStudent(index) {
      this.studentListIndex = index;
      this.GetSchoolHealthyInfo();
    },
    onClickClass(index) {
      this.currentIndex = index;
      this.GetSchoolHealthyInfo();
    },
    async GetStudentInfoByClassId() {
      let res = await GetStudentInfoByClassId({
        Id: this.classList[this.currentIndex].Id,
      });
      if (res.data.success) {
        this.studentList = res.data.response;
        this.allStudentList = res.data.response;
      }
    },
    async GetSchoolHealthyInfo() {
      let res = await GetSchoolHealthyInfo({
        SexType: this.studentListIndex,
        ClassId: this.classList[this.currentIndex].Id,
      });
      if (res.data.success) {
        this.getDataPie(res.data.response);
      }
    },
    onChangeCycle(e) {
      this.CycleListValue = e;
      this.GetSchoolDietaryInfo();
    },
    // 膳食周期
    async GetOpenCycleInfoSelectResult() {
      let res = await GetOpenCycleInfoSelectResult({
        SchoolId: this.userInfo.SchoolId,
      });
      if (res.data.success) {
        this.CycleList = res.data.response;
        this.allCycleList = res.data.response;
      }
    },
    // 膳食营养
    async GetSchoolDietaryInfo() {
      let res = await GetSchoolDietaryInfo({ Id: this.CycleListValue });
      if (res.data.success) {
        this.DietaryInfo = res.data.response;
      }
    },
    async GetSchoolCloudDiskInfo() {
      let res = await GetSchoolCloudDiskInfo();
      if (res.data.success) {
        this.ChildTray = [
          {
            title: "照片",
            count: res.data.response.PictureNum,
            img: require("../assets/ChildTray-f1.png"),
          },
          {
            title: "视频",
            count: res.data.response.VideoNum,
            img: require("../assets/ChildTray-f2.png"),
          },
          {
            title: "报告",
            count: res.data.response.ReportNum,
            img: require("../assets/ChildTray-f1.png"),
          },
        ];
        this.teacherTray = [
          {
            title: "课件",
            count: res.data.response.CoursewareNum,
            img: require("../assets/ChildTray-f1.png"),
          },
          {
            title: "共享文件",
            count: res.data.response.ShareFileNum,
            img: require("../assets/ChildTray-f2.png"),
          },
          {
            title: "个人文件",
            count: res.data.response.FileNum,
            img: require("../assets/ChildTray-f2.png"),
          },
        ];
      }
    },
    async GetSchoolScienceInfo() {
      let res = await GetSchoolScienceInfo();
      if (res.data.success) {
        this.smallChildrenList = [
          {
            title: "绘本数量",
            count: res.data.response.PictureBookNum,
            img: require("../assets/small-f1.png"),
          },
          {
            title: "家长课程",
            count: res.data.response.ParentCurriculumNum,
            img: require("../assets/small-f2.png"),
          },
          {
            title: "书盒子",
            count: res.data.response.ParentLookNum,
            img: require("../assets/small-f3.png"),
          },
        ];
        this.smallTeacherList = [
          {
            title: "学习资源库",
            count: res.data.response.StudyResourcesNum,
            img: require("../assets/small-f4.png"),
          },
          {
            title: "教师讲坛视频",
            count: res.data.response.TeacherForumNum,
            img: require("../assets/small-f5.png"),
          },
          {
            title: "课题研究资料",
            count: res.data.response.SubjectResearchNum,
            img: require("../assets/small-f6.png"),
          },
        ];
      }
    },
    async GetSchoolBaseInfo() {
      let res = await GetSchoolBaseInfo();
      if (res.data.success) {
        this.headerList = [
          {
            title: "教职工数",
            count: res.data.response.TeacherNum,
            img: require("../assets/header-f1.png"),
          },
          {
            title: "班级数量",
            count: res.data.response.ClassNum,
            img: require("../assets/header-f2.png"),
          },
          {
            title: "幼儿人数",
            count: res.data.response.StudentNum,
            img: require("../assets/header-f3.png"),
          },
          {
            title: "男生人数",
            count: res.data.response.BoyNum,
            img: require("../assets/header-f4.png"),
          },
          {
            title: "女生人数",
            count: res.data.response.GirlNum,
            img: require("../assets/header-f5.png"),
          },
        ];
        this.scrollInfo = res.data.response;
      }
    },
    onChangeTeacher(e) {
      this.classListThemeId = e;
      this.GetWebStudentAttendStatis();
      ;
    },
    // 获取幼儿下拉数据
    async GetTeacherClassRoleInfo() {
      let xhr = await GetTeacherClassRoleInfo();
      let themeArr = [];
      let classArr = [];
      if (this.userInfo.UserIdentity == "1") {
        classArr.push({
          GradeNameAndClassName: "全园",
          ClassName: "全园",
          GradeName: "全园",
          Id: 0,
        });
      }
      xhr.data.response.forEach((Gradeitem) => {
        Gradeitem.ClassInfo.forEach((classItem) => {
          classArr.push({
            GradeNameAndClassName:
              Gradeitem.GradeName + (classItem.Name ? classItem.Name : ""),
            ClassName: classItem.Name ? classItem.Name : "",
            Id: classItem.Id,
            ...Gradeitem,
          });
        });
      });

      this.classList = classArr;
      this.allClassList = classArr;
      this.taskAllClassList = classArr;
      this.classListTheme = themeArr;
      this.allClassId = this.allClassList[0].Id;
      this.taskAllClassId = this.taskAllClassList[0].Id;
    },
    // 幼儿考勤
    async GetWebStudentAttendStatis() {
      let res = await GetWebStudentAttendStatis({
        Id: this.classListThemeId,
      });
      if (res.data.success) {
        this.childrenList = [
          {
            title: "总人数",
            count: res.data.response.TotalNum,
            img: require("../assets/children-f2.png"),
          },
          {
            title: "今日入园",
            count: res.data.response.ClockNum,
            img: require("../assets/children-f3.png"),
          },
          {
            title: "出勤率",
            count: res.data.response.Attendance,
            img: require("../assets/children-f4.png"),
          },
        ];
      }
    },
    // 教师考勤
    async GetTeacherAttendStatis() {
      let res = await GetTeacherAttendStatis();
      if (res.data.success) {
        this.teacherList = [
          {
            title: "总人数",
            count: res.data.response.TotalNum,
            img: require("../assets/teacher-f2.png"),
          },
          {
            title: "今日入园",
            count: res.data.response.ClockNum,
            img: require("../assets/teacher-f3.png"),
          },
          {
            title: "出勤率",
            count: res.data.response.Attendance,
            img: require("../assets/teacher-f4.png"),
          },
        ];
      }
    },
    getDataPie(dataInfo) {
      // 基于准备好的dom，初始化echarts实例
      let myChart = this.$echarts.init(document.getElementById("echartsPie"));
      // 绘制图表
      myChart.setOption({
        title: {
          text: "特殊幼儿占比",
          subtext: "体检结果",
          x: "center",
          y: "bottom",
          textStyle: {
            //主标题文本样式{"fontSize": 18,"fontWeight": "bolder","color": "#333"}
            fontSize: 12,
            color: "#666",
          },
        },
        tooltip: {
          // trigger 设置触发类型，默认数据触发，可选值：'item' ¦ 'axis'
          trigger: "item",
          formatter: "{a} <br/>{b} : {c}个 ({d}%)",
        },

        color: ["#CFA0FF", "#8F9CFD"],

        series: [
          {
            name: "体检结果",
            type: "pie",
            // radius: '50%',  // 设置饼状图大小，100%时，最大直径=整个图形的min(宽，高)
            radius: ["40%", "60%"], // 设置环形饼状图， 第一个百分数设置内圈大小，第二个百分数设置外圈大小
            center: ["50%", "45%"], // 设置饼状图位置，第一个百分数调水平位置，第二个百分数调垂直位置
            data: dataInfo,
            // itemStyle 设置饼状图扇形区域样式
            itemStyle: {
              // emphasis：英文意思是 强调;着重;（轮廓、图形等的）鲜明;突出，重读
              // emphasis：设置鼠标放到哪一块扇形上面的时候，扇形样式、阴影
              emphasis: {
                shadowBlur: 10,
                shadowOffsetX: 0,
              },
              normal: {
                label: {
                  show: true,
                  position: "outer",
                  formatter: "{b}：{c}",
                },
              },
            },
            // 设置值域的那指向线
            labelLine: {
              normal: {
                show: true, // show设置线是否显示，默认为true，可选值：true ¦ false
              },
            },
          },
        ],
      });
    },
  },
};
</script>
<style lang="less" scoped>
.el-row {
  margin-bottom: 20px;
  &:last-child {
    margin-bottom: 0;
  }
}
.seamless-warp {
  height: 2rem;
  overflow: hidden;
  margin-top: 0.15rem;
}
.tui-taskTitle {
  font-size: 0.175rem;
  font-weight: 500;
  padding: 0.125rem 0 0 0;
}
.tui-task/deep/.el-card__header {
  background: #fff8f0;
}
.tui-progressTitle {
  font-size: 0.25rem;
  font-weight: 500;
  padding-right: 0.125rem;
  flex-shrink: 0;
}
.tui-progressResult {
  width: 1.5rem;
  font-size: 0.225rem;
  color: #666;
  font-weight: 500;
  padding-left: 0.125rem;
  flex-shrink: 0;
}
.tui-progress {
  width: 4.2125rem;
  height: 0.25rem;
  background: rgba(143, 156, 253, 0.28);
  border-radius: 0.1375rem;
  position: relative;
  div {
    position: absolute;
    left: 0;
    background: #8f9cfd;
    height: inherit;
    border-radius: 0.1375rem;
  }
}
/deep/.el-input__inner {
  width: 162px;
  height: 38px;
  border-radius: 20px;
  color: #333;
}
.tui-headerTitle {
  font-size: 28px;
  font-weight: 500;
}
.tui-border {
  width: 1px;
  height: 3.2375rem;
  border: 1px solid #ededed;
  margin-right: 0.4375rem;
}
.tui-bottomTitle {
  font-size: 0.25rem;
  font-weight: 500;
  text-align: left;
}
.tui-before {
  width: 0.075rem;
  height: 0.2375rem;
  background: #5e99ff;
  border-radius: 3px;
  margin-right: 0.125rem;
}
.tui-margin {
  margin: 0 0 0 0.25rem !important;
}
.tui-nutrition {
  font-size: 0.2rem;
  color: #333;
  font-weight: bold;
  padding-top: 1rem;
  padding-left: 1.325rem;
  span {
    font-size: 0.45rem;
    color: #e02020;
    font-weight: bold;
    padding-left: 0.275rem;
  }
}
.box-card {
  height: 4.375rem;
}
.tui-details {
  position: absolute;
  bottom: 0.25rem;
  right: 0.25rem;
  display: flex;
  align-items: center;
  color: #4083fe;
  font-size: 0.175rem;
}
.tui-sexTab {
  display: flex;
  flex-direction: column;
  .tui-sexTabItem {
    width: 1.45rem;
    height: 0.375rem;
    border-radius: 3px;
    border: 1px solid #cdcdcd;
    font-size: 0.175rem;
    color: #333;
    font-weight: 500;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0 0 0.25rem 0;
  }
  .tui-sexTabItemActive {
    background: #cbd6ff;
    font-weight: bold !important;
  }
}
.tui-healthLeft::-webkit-scrollbar {
  /*滚动条整体样式*/
  width: 10px; /*高宽分别对应横竖滚动条的尺寸*/
  height: 1px;
}

.tui-healthLeft::-webkit-scrollbar-thumb {
  /*滚动条里面小方块*/
  border-radius: 10px;
  -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  background: #9d9d9d;
  opacity: 1;
}

.tui-healthLeft::-webkit-scrollbar-track {
  /*滚动条里面轨道*/
  -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  border-radius: 10px;
  background: #ededed;
}
.tui-healthLeftActive {
  background: #cbd6ff;
}
.tui-healthLeft {
  width: 1.875rem;
  height: 2.825rem;
  border-radius: 0.1875rem;
  border: 1px solid #cdcdcd;
  overflow-y: scroll;
  div {
    cursor: pointer;
    width: 1.2375rem;
    height: 0.3375rem;
    font-size: 0.175rem;
    font-weight: 500;
    color: #333;
    margin: 0.25rem auto;
    // padding: 0.25rem 0;
    text-align: center;
    border-radius: 0.25rem;
  }
}
.tui-cardTitle {
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 0.275rem;
  font-weight: 600;
  color: #333;
}
.tui-right {
  display: flex;
  align-items: center;
  flex-wrap: nowrap;
  width: 100%;
  .tui-rightItem {
    width: calc(100% / 5);
    display: flex;
    align-items: center;
    justify-content: center;
    margin-left: 0.625rem;
    img {
      width: 0.825rem;
      height: 0.825rem;
    }
    .tui-rightItemBox {
      flex-direction: column;
      padding-left: 0.325rem;
      .tui-Num {
        font-size: 0.4rem;
        font-weight: 500;
        color: #333;
      }
      .tui-desc {
        font-size: 0.15rem;
        font-weight: 500;
        color: #333;
        // padding-top: 0.175rem;
      }
    }
  }
}
.tui-left {
  width: 25%;
  display: flex;
  align-items: center;
  justify-content: space-around;
  .tui-leftContent {
    flex-direction: column;
    align-items: center;
    justify-content: center;
    .tui-leftTitle {
      font-size: 0.25rem;
      color: #333;
      font-weight: 600;
      padding-bottom: 0.6625rem;
    }
    .tui-leftBtn {
      width: 0.9rem;
      height: 0.4125rem;
      background: linear-gradient(172deg, #f0f3ff 0%, #d4ddff 100%);
      box-shadow: inset 0px 1px 3px 0px rgba(255, 255, 255, 1);
      border-radius: 0.2125rem;
      border: 1px solid #0b22b3;
      font-size: 0.25rem;
      color: #0b22b3;
      font-weight: 500;
    }
    .tui-leftDesc {
      font-size: 0.175rem;
      font-weight: 500;
      padding-top: 0.125rem;
    }
  }
}
</style>